import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  fontSize?: '12';
  fontWeight?: '500';
  align?: 'center';
  lineHeight?: '17';
  letterSpacing?: '0_17';
  className?: string;
}

const Paragraph: FC<IProps> = ({
  children,
  fontSize,
  fontWeight,
  align,
  lineHeight,
  letterSpacing,
  className,
}) => {
  return (
    <p
      className={classNames(
        css.paragraph,
        { [css[`paragraph_fontSize_${fontSize}`]]: fontSize },
        { [css[`paragraph_fontWeight_${fontWeight}`]]: fontWeight },
        { [css[`paragraph_align_${align}`]]: align },
        { [css[`paragraph_lineHeight_${lineHeight}`]]: lineHeight },
        { [css[`paragraph_letterSpacing_${letterSpacing}`]]: letterSpacing },
        className,
      )}
    >
      {children}
    </p>
  );
};

export default Paragraph;
